import { useState } from 'react';

interface UseTruncatedTextProps {
  text?: string | null;
  previewLimit: number;
  fullLimit: number;
}

export const useExpandableText = ({
  text,
  previewLimit,
  fullLimit,
}: UseTruncatedTextProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) {
    return { isExpanded, visibleText: '', canExpand: false, setIsExpanded };
  }

  const previewText =
    text.length > previewLimit ? `${text.slice(0, previewLimit)}…` : text;
  const fullText =
    text.length > fullLimit ? `${text.slice(0, fullLimit)}…` : text;
  const visibleText = isExpanded ? fullText : previewText;

  const canExpand = text.length > previewLimit;

  return { isExpanded, visibleText, canExpand, setIsExpanded };
};
